import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './GridProjects.css';

// Example data
const defaultProjects = [
    { id: '1', title: 'Game Project (Godot)', imgSrc: 'https://media.giphy.com/media/9uCu61No4nesLvGDnI/giphy.gif' },
    { id: '2', title: 'OpenGL Project (C)', imgSrc: 'https://media.giphy.com/media/8M4uldLPvE6YIuTgKN/giphy.gif' },
    { id: '3', title: 'LeetCode Problems', imgSrc: 'https://media.giphy.com/media/WdGByl1b03cWrOTJbh/giphy.gif' },
    { id: '4', title: 'Multi-Purpose Translator', imgSrc: 'https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnZzZThkc3BsNTNwdHU5ODQzMGtjaDh0MDh2Ym0wMXlhamd3ajhzcyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/OBqxAqSFNUBXXW79En/giphy-downsized-large.gif' },
    { id: '5', title: 'Tkinter ERP System', imgSrc: 'https://media.giphy.com/media/fMLOeKyZEOvnjGThyZ/giphy.gif' },
    //{ id: '6', title: 'Weather App', imgSrc: 'https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExYjF1dzE3b2g1dDUzZTR3YjZrd3h4c2VneGF1dHgxcG82aTg0eHVlcCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/ZMhs0x9ZUtLHTIQ7Gd/giphy.gif' },
    { id: '7', title: 'Docker Deployment', imgSrc: 'https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExd3cwaGw3YnVrZ2ozcWtqOG0xaWQzdTY3cjloaWM2a3oxNDcxdXFtMSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/clqzXQbfQRZenDrRJZ/giphy.gif' },
    // Add more projects as needed and don't duplicate IDS!! have to be unique
];

const GridProjects = ({ projects = defaultProjects }) => {
    const scrollContainerRef = useRef(null);
    const [scrolling, setScrolling] = useState(false);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        const scrollItems = scrollContainer.children;
        const totalItems = scrollItems.length;
        const itemWidth = scrollItems[0].getBoundingClientRect().width;
        const containerWidth = scrollContainer.getBoundingClientRect().width;

        let scrollPosition = 0;
        const scrollAmount = itemWidth + 4; // Item width + margin

        const startAutoScroll = () => {
            const interval = setInterval(() => {
                if (!scrolling) {
                    scrollPosition += scrollAmount;
                    if (scrollPosition > (totalItems - 1) * scrollAmount) {
                        scrollPosition = 0;
                    }
                    scrollContainer.scrollTo({
                        left: scrollPosition,
                        behavior: 'smooth',
                    });
                }
            }, 3000); // Adjust the speed here
            return interval;
        };

        const interval = startAutoScroll();

        const handleTouchStart = () => {
            setScrolling(true);
            clearInterval(interval);
        };

        const handleTouchEnd = () => {
            setScrolling(false);
            startAutoScroll();
        };

        scrollContainer.addEventListener('touchstart', handleTouchStart);
        scrollContainer.addEventListener('touchend', handleTouchEnd);

        return () => {
            scrollContainer.removeEventListener('touchstart', handleTouchStart);
            scrollContainer.removeEventListener('touchend', handleTouchEnd);
            clearInterval(interval);
        };
    }, [scrolling]);

    return (
        <Container fluid className='projects-grid-container'>

            {/* Desktop grid layout */}
            <br/>
            <Row className='d-none d-sm-flex'>
                {projects.map((project) => (
                    <Col xs={12} sm={6} md={4} lg={4} key={project.id} className='mb-4'>
                        <div className='grid-item'>
                            <Link to={`/project/${project.id}`}>
                                <img src={project.imgSrc} alt={project.title} className='grid-img' />
                                <div className='grid-title'>{project.title}</div>
                            </Link>
                        </div>
                    </Col>
                ))}
            </Row>
            {/* Mobile horizontal scroll layout */}
            <div className='d-block d-sm-none'>
                <div className='horizontal-scroll-wrapper'>
                    <div className='horizontal-scroll-container' ref={scrollContainerRef}>
                        {projects.concat(projects).map((project) => (
                            <div className='grid-item' key={project.id}>
                                <Link to={`/project/${project.id}`}>
                                    <img src={project.imgSrc} alt={project.title} className='grid-img' />
                                    <div className='grid-title'>{project.title}</div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default GridProjects;
